let echarts = require('echarts')

export const chartOption = {
  tooltip: {
    trigger: 'axis'
  },
  grid: {
    left: '10px',
    right: '10px',
    bottom: '30px',
    containLabel: true
  },
  xAxis: {
    data: [],
    axisLabel: {
      formatter: function (value) {
        return subStr(value)
      },
    }
  },
  yAxis: {},
  series: [{
    name: '',
    type: 'line',
    smooth: true,
    symbol: 'none',
    areaStyle: {
      normal: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#FF7C73'
          },
          {
            offset: 1,
            color: '#fff'
          }
        ], false)
      }
    },
    lineStyle:{ // 折线的颜色
      color:'#FF7C73'
    },
    itemStyle:{
      normal : { // 点的颜色
        color:'#FF7C73'
      }
    },
    data: []
  }]
}
function subStr (str){
  // 设置变量存储返回值
  let newstr = "";
  // 如果长度超过5，就要截取插入字符
  if(str.length > 7) {
    // 第一次截取
    newstr = str.slice(0, 7) + "\n";
    // 闭包再次调用，如果截取后的字段长度依然超过5，再次调用，如果没有直接返回当前值
    return newstr + subStr(str.slice(7));
  } else {
    // 直接返回当前值
    return str
  }
}
